import { useFeatureFlags } from '@usap/core'

const useIsPromoBadgeEnabled = () => {
    const { f69 } = useFeatureFlags()
    const enabled = new Set(['b', '1', 1, 'on', 'true', true])

    return enabled.has(f69 as string | number | boolean)
};

export default useIsPromoBadgeEnabled